import { render, staticRenderFns } from "./coinsShop.vue?vue&type=template&id=8346bc68&scoped=true&"
import script from "./coinsShop.vue?vue&type=script&lang=js&"
export * from "./coinsShop.vue?vue&type=script&lang=js&"
import style0 from "./coinsShop.vue?vue&type=style&index=0&id=8346bc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8346bc68",
  null
  
)

export default component.exports